"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gatherer = void 0;
const Resources_1 = require("../../Resources");
const IAward_1 = require("../IAward");
class Gatherer {
    constructor() {
        this.name = 'Gatherer';
        this.description = 'Have the most different types of resources';
    }
    getScore(player) {
        const standardResources = [Resources_1.Resources.MEGACREDITS, Resources_1.Resources.STEEL, Resources_1.Resources.TITANIUM, Resources_1.Resources.PLANTS, Resources_1.Resources.ENERGY, Resources_1.Resources.HEAT]
            .filter((res) => player.getResource(res) > 0).length;
        const nonStandardResources = new Set(player.getCardsWithResources().map((card) => card.resourceType)).size;
        let score = standardResources + nonStandardResources;
        return score + IAward_1.getAdditionalScore(player);
    }
}
exports.Gatherer = Gatherer;
//# sourceMappingURL=Gatherer.js.map